import { translations } from "@timeedit/registration-shared";

// Using as const we want the type to be inferred
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function getEndpoints() {
  return {
    root: {
      path: "",
      name: translations.registration,
    },
    registration: {
      path: "registration",
      name: translations.registration,
    },
    groups: {
      path: "registration/:id",
      name: translations.groups,
    },
    schedule: {
      path: "schedule",
      name: translations.schedule,
    },
  } as const;
}

type Endpoints = ReturnType<typeof getEndpoints>;
type EndPoint = Endpoints[keyof Endpoints];
export type EndPointPath = EndPoint["path"];
